// extracted by mini-css-extract-plugin
module.exports = {"root":"NewFooter_root__3Jmi7","label":"NewFooter_label__3gZ9x","languageBtn":"NewFooter_languageBtn__vr8Om"};